import * as Sentry from '@sentry/react';
import type { PropsWithChildren } from 'react';

import { ErrorFallback } from './ErrorFallback';

const isReporting = () => {
  const client = Sentry.getClient();
  return !!client && client.getOptions().enabled !== false;
};

const renderFallback = ({ eventId }: { eventId: string }) => (
  <ErrorFallback eventId={isReporting() ? eventId : undefined} />
);

export const AppErrorBoundary = ({ children }: PropsWithChildren) => (
  <Sentry.ErrorBoundary fallback={renderFallback}>{children}</Sentry.ErrorBoundary>
);
